import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a6016a0e5bb54b73524a37858ef63361ab from "./generated-bb259f58-1461-4a32-ab82-42fb91bd3066.json";

import a13252ebcbdf874d6a1e5ff514ef674f9b from "./generated-241e95c3-775d-4606-949b-65172ee3beb2.json";

import aec8b7a4e3ff7d7775a1986472c39c8a6b from "./generated-59658d06-c019-4d6c-b261-f5e471bf3f11.json";

import a9024b19abd3185b83fc1b01e7ba43645b from "./generated-0a22721d-a570-48df-a0c0-39a442b3d2bd.json";

import a92fcc93718ed9cb3bfb37241e3bcef10b from "./generated-4d98df3e-419d-4c23-8fbd-1edba007d49f.json";

import a5971e15364f012f49bf94c9066a4d592b from "./generated-39af107e-046c-4d8c-bde6-4bc5e74166bf.json";

import a5557db92bc9bc96ec7e8a7ecf0635084b from "./generated-a5e27a02-6eae-47de-a5db-e041accf07bb.json";

import a0d10ffb3d71520fee4854d4d6674eac3b from "./generated-4db096be-bbe6-4cf5-8093-4f3da89ef88e.json";

import a2f30f77d5192d2894f5e4d9a3d88b465b from "./generated-36fb972e-db2f-45e6-a068-75a6bb16cf78.json";

import ac34afe3020f45adeac3c29ae9e482215b from "./generated-516f5932-0924-45bf-a38f-9f8fcc622958.json";

import aaa5f9aaf022d31b433628c3fe4b7a613b from "./generated-c15b403d-6782-412a-8463-289cdfcf6012.json";

import a2cc7c4a2b9689ecf9312ae4dc158a6a6b from "./generated-fef8108d-f940-4d63-a134-53813e92bd09.json";

import ac90626774368c4c17bae10e30bd29004b from "./generated-637d5cce-8925-4eca-b56d-0e01ee63210b.json";

import a92ff4020fa70cdcb6d2cdd47556dbfacb from "./generated-93899f92-fac1-48c3-ad99-5ce60ea95eaa.json";

import a10e99c56229f6261aa35082e5760daceb from "./generated-dc6ed17f-1eb7-4fbf-ab80-1cf06d13073c.json";

import a1e6d415894ac693a03f6e383d38f67deb from "./generated-118182b5-d919-4548-9685-ae3f86d950d6.json";

import a46ee2aaae2bc6111698cacae5b90ab49b from "./generated-bac6d85a-b1d7-4f37-bbe4-f419839062ac.json";

import a8cde970fd19aded2b7ff166a21f2c170b from "./generated-6ca29977-4f14-4a28-a6c6-ef9cb9cfc5c6.json";

import a779c7afe0733f6c5575658f4dddcd498b from "./generated-00ff43c1-d0ef-4d86-9dd3-6b8702a0385b.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a6016a0e5bb54b73524a37858ef63361ab);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a13252ebcbdf874d6a1e5ff514ef674f9b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(aec8b7a4e3ff7d7775a1986472c39c8a6b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a9024b19abd3185b83fc1b01e7ba43645b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a92fcc93718ed9cb3bfb37241e3bcef10b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a5971e15364f012f49bf94c9066a4d592b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a5557db92bc9bc96ec7e8a7ecf0635084b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a0d10ffb3d71520fee4854d4d6674eac3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a2f30f77d5192d2894f5e4d9a3d88b465b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ac34afe3020f45adeac3c29ae9e482215b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(aaa5f9aaf022d31b433628c3fe4b7a613b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a2cc7c4a2b9689ecf9312ae4dc158a6a6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(ac90626774368c4c17bae10e30bd29004b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a92ff4020fa70cdcb6d2cdd47556dbfacb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a10e99c56229f6261aa35082e5760daceb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a1e6d415894ac693a03f6e383d38f67deb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a46ee2aaae2bc6111698cacae5b90ab49b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a8cde970fd19aded2b7ff166a21f2c170b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a779c7afe0733f6c5575658f4dddcd498b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a46ee2aaae2bc6111698cacae5b90ab49b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */